import type { ThemeState } from '@atlaskit/tokens/theme-config';

/**
 * The themes atlassian.design is built with.
 *
 * Used by `gatsby-ssr.js` for the prerendered `<head>` and by `Layout` at runtime. If
 * the two disagree, the page repaints after hydration.
 */
export const DOCS_THEME_SETTINGS = {
	dark: 'dark',
	light: 'light',
	motion: 'motion',
	shape: 'shape',
	spacing: 'spacing',
	typography: 'typography',
} as const;

/**
 * The theme state the site is prerendered with.
 *
 * One build is served to every reader, so color mode is `auto`: token CSS for both color modes is
 * inlined and the pre-paint scripts pick one. `@atlaskit/tokens` writes `auto` as `light` in the
 * prerendered attributes.
 *
 * `contrastMode` is stated even though increased-contrast themes are flagged off for this site,
 * because `getThemeStyles` already defaults it to `auto`. The day the flag turns on, the html
 * attributes and the pre-paint script have to agree with the CSS being inlined.
 */
export const DOCS_SSR_THEME_STATE: Partial<ThemeState> & {
	colorMode: 'auto';
	contrastMode: 'auto';
} = {
	...DOCS_THEME_SETTINGS,
	colorMode: 'auto',
	contrastMode: 'auto',
};
